import React, { memo } from 'react'
import is from 'ramda/src/is'
import addIndex from 'ramda/src/addIndex'
import map from 'ramda/src/map'
import {
	fontFamily,
	ltGtMediaQuery,
	errorColor,
	colorsNew,
} from 'root/src/client/web/commonStyles'
import withStyles from '@material-ui/core/styles/withStyles'
import { ternary } from 'root/src/shared/util/ramdaPlus'
import classNames from 'classnames'
import TooltipWraper from 'root/src/client/web/base/TooltipWraper'

const variants = {
	small: {
		fontSize: 12,
	},
}

const styles = {
	fontStyle: {
		fontFamily,
		fontWeight: 400,
		fontSize: 20,
		lineHeight: 1.2,
		[ltGtMediaQuery]: {
			fontSize: 17,
		},
	},
	required: {
		color: errorColor,
	},
	subText: {
		display: 'block',
		fontWeight: 400,
		fontSize: 16,
	},
	tooltip: {
		marginLeft: 8,
		fontSize: '.6em',
		width: 20,
		height: 20,
		borderRadius: '100%',
		backgroundColor: colorsNew.dark1,
		display: 'grid',
		placeContent: 'center',
	},
	...variants,
}

export const TitleFormTextUnstyled = memo((({ classes, children, variant }) => (
	<div className={classNames(classes.fontStyle, { [classes[variant]]: variant })}>
		{ternary(
			is(Array, children),
			addIndex(map)((obj, i) => {
				if (obj.required) {
					if (obj.subText) {
						return (
							<span key={i}>
								<span>
									{obj.text}<span className={classes.required}>*</span>:
								</span>
								<span className={classes.subText}>{obj.subText}</span>
							</span>
						)
					}

					return (
						<span key={i}>
							{obj.text}<span className={classes.required}>*</span>:
						</span>
					)
				}
				return (
					<span style={{ display: 'flex' }} key={i}>
						<span className={classes.subText}>{obj.subText}</span>
						{`${obj.text}:`}
						{obj.tooltip && (
							<TooltipWraper
								tooltipText={obj.tooltip}
							>
								<div className={classes.tooltip}>?</div>
							</TooltipWraper>
						)}
					</span>
				)
			}, children),
			<span>{children}</span>,
		)}
	</div>
)))

export default withStyles(styles, { name: 'MuiTitleFormText' })(TitleFormTextUnstyled)
